export default "__VITE_ASSET__JinCq33x__"